export default "__VITE_ASSET__smFBX$1B__"